export type CreditHistoryCategory = "safe" | "privacy" | "activity" | "other";

export interface CategorizedCreditEvent {
  timestamp: Date;
  month: string; // "YYYY-MM"
  result: string;
  category: CreditHistoryCategory;
}

export const CATEGORY_LABELS: Record<CreditHistoryCategory, string> = {
  safe: "Safe",
  privacy: "Privacy",
  activity: "Activity",
  other: "Other",
};

// Tailwind classes for badges / chart cells. Aligns with brand palette where possible.
export const CATEGORY_BADGE_CLASS: Record<CreditHistoryCategory, string> = {
  safe: "bg-green-100 text-green-800 border-green-200",
  privacy: "bg-amber-100 text-amber-800 border-amber-200",
  activity: "bg-teal-100 text-teal-800 border-teal-200",
  other: "bg-gray-100 text-gray-700 border-gray-200",
};

export const CATEGORY_CHART_COLOR: Record<CreditHistoryCategory, string> = {
  safe: "hsl(142, 76%, 36%)",
  privacy: "hsl(38, 92%, 50%)",
  activity: "hsl(173, 58%, 39%)",
  other: "hsl(220, 9%, 60%)",
};

export function categorizeResult(result: string): CreditHistoryCategory {
  const r = (result || "").toLowerCase();
  if (
    r.includes("safe") ||
    r.includes("no danger") ||
    r.includes("no bounding boxes")
  ) {
    return "safe";
  }
  if (r.includes("blurred face") || r.includes("phone usage")) {
    return "privacy";
  }
  if (r.includes("eating") || r.includes("drinking") || r.includes("person")) {
    return "activity";
  }
  return "other";
}
